import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17 2.25a.75.75 0 0 1 .75.75v1.25H20c.966 0 1.75.784 1.75 1.75v11A1.75 1.75 0 0 1 20 18.75h-1.25V20A1.75 1.75 0 0 1 17 21.75H4A1.75 1.75 0 0 1 2.25 20V8c0-.966.784-1.75 1.75-1.75h1.25V6c0-.966.784-1.75 1.75-1.75h2.25V3a.75.75 0 0 1 1.5 0v1.25h5.5V3a.75.75 0 0 1 .75-.75M4 7.75a.25.25 0 0 0-.25.25v12c0 .138.112.25.25.25h13a.25.25 0 0 0 .25-.25v-1.25H7A1.75 1.75 0 0 1 5.25 17V7.75zm3-2a.25.25 0 0 0-.25.25v11c0 .138.112.25.25.25h13a.25.25 0 0 0 .25-.25V6a.25.25 0 0 0-.25-.25h-2.25V7a.75.75 0 0 1-1.5 0V5.75h-5.5V7a.75.75 0 0 1-1.5 0V5.75z"
    }, null, -1)
  ])))
}
export default { render: render }